"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzProjectTag__Wrapper",
  componentId: "sc-19nrnwr-0"
})(["\n  position: relative;\n  display: flex;\n  align-items: ", ";\n  width: 100%;\n"], function (props) {
  return props.direction === "vertical" ? "stretch" : "baseline";
});

var Color = _styledComponents.default.div.withConfig({
  displayName: "OzProjectTag__Color",
  componentId: "sc-19nrnwr-1"
})(["\n  background-color: ", ";\n  width: 10px;\n  ", ";\n  border-radius: 5px;\n  margin-right: 10px;\n"], function (props) {
  return props.color;
}, function (props) {
  return props.direction === "horizontal" ? "height: 10px;" : null;
});

var Content = _styledComponents.default.div.withConfig({
  displayName: "OzProjectTag__Content",
  componentId: "sc-19nrnwr-2"
})(["\n  text-align: left;\n  width: 100%;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n\n"], function (props) {
  return props.direction === "vertical" ? "column" : "row";
});

var Name = _styledComponents.default.div.withConfig({
  displayName: "OzProjectTag__Name",
  componentId: "sc-19nrnwr-3"
})(["\n  color: ", ";\n  font-size: 12px;\n  margin-top: ", "px;\n  margin-bottom: 6px;\n"], function (props) {
  return props.variant === "dark" ? "#303030" : "#ffffff";
}, function (props) {
  return props.direction === "vertical" && props.uuid ? 0 : 6;
});

var Uuid = _styledComponents.default.div.withConfig({
  displayName: "OzProjectTag__Uuid",
  componentId: "sc-19nrnwr-4"
})(["\n  color: ", ";\n  font-size: 12px;\n  margin-top: ", "px;\n"], function (props) {
  return props.variant === "dark" ? "#30303099" : "#ffffff99";
}, function (props) {
  return props.direction === "vertical" ? 0 : 6;
});

var OzProjectTag = function OzProjectTag(_ref) {
  var name = _ref.name,
      uuid = _ref.uuid,
      color = _ref.color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "dark" : _ref$variant;
  return __jsx(Wrapper, {
    direction: direction
  }, color ? __jsx(Color, {
    color: color,
    direction: direction
  }) : null, __jsx(Content, {
    direction: direction
  }, __jsx(Name, {
    variant: variant,
    direction: direction,
    uuid: uuid
  }, name), uuid ? __jsx(Uuid, {
    variant: variant,
    direction: direction
  }, uuid) : null));
};

var _default = OzProjectTag;
exports.default = _default;